import { IndividualObject } from 'generated/graphql'

type TaskIndividualHeaderProps = {
  individual: IndividualObject
}

const createFullName = (individual: IndividualObject): string =>
  [individual.firstName, individual.middleName, individual.lastName]
    .filter(Boolean)
    .join(' ')

const createSubtitle = (individual: IndividualObject): string =>
  individual.type ? individual.type.replace(/_/g, ' ').toLowerCase() : ''

export const TaskIndividualHeader = ({
  individual
}: TaskIndividualHeaderProps) => {
  if (!individual) return null

  const title = createFullName(individual)
  const subTitle = createSubtitle(individual)

  return (
    <div
      className="flex shrink-0 items-center gap-1"
      data-testid="individual-name"
      key={individual.id}
    >
      <div className="font-semibold">
        {title}
        {subTitle ? ',' : ''}
      </div>
      {subTitle && (
        <div className="truncate text-gray-600" title={subTitle}>
          {subTitle}
        </div>
      )}
    </div>
  )
}
